import { ReactNode } from "react";
import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

export const Skeleton = styled.div<{ width?: string; height?: string }>`
  display: inline-block;
  height: ${({ height }) => height || "18px"};
  width: ${({ width }) => width || "80px"};
  border-radius: 10px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: ${pulse} 1.4s ease infinite;
`;

export function MetricsLoading({
  loading,
  value,
  unit = "",
  width,
  height,
}: {
  loading: boolean;
  value: string | number | undefined | null | ReactNode;
  unit?: string;
  width?: string;
  height?: string;
}) {
  if (loading) return <Skeleton width={width} height={height} />;
  return value !== null && value !== "" ? (
    <>
      {value} {unit}
    </>
  ) : (
    <>--</>
  );
}
